<div data-testid="commission-by-submit-to-container">
  <app-generic-chart 
    [data]="data" 
    [presentationType]="presentationType"
    [chartConfiguration]="chartConfiguration">
  </app-generic-chart>
</div>